export default Object.freeze([
  'Высшее',
  'Среднее специальное',
  'Среднее общее',
  'Неполное общее',
  'Неоконченное Высшее',
  'Неграмотный',
])
